import { getUrl } from '@/common/oldMobile';
import { fireGAEvent } from '@/analytics';
import axios from 'axios';
import { catcher } from '@/_http/utils';
import { getProperty } from '@/common/oldMobile';

export const changeLang = function(lang) {
    fireGAEvent('Osobna zona', `Jazyk ${lang.toUpperCase()}`);
    axios
        .get(getUrl('CHANGE_LOCALE'), { params: { lang } })
        .then(() => window.location.reload())
        .catch(catcher.swallow);
};

export const localLang = getProperty('locale');
